













































































































import {
  Vue,
  Component,
  Watch,
} from 'vue-property-decorator';
import { DataOptions } from 'vuetify';
import { getModule } from 'vuex-module-decorators';
import OrderRepository from '@/repositories/OrderRepository';
import FilterParametersRepository from '@/repositories/FilterParametersRepository';
import DynamicColumnMenu from '@/components/tables/DynamicColumnMenu.vue';
import ButtonFilterMenuOptions from '@/components/buttons/ButtonFilterMenuOptions.vue';
import Orders from '@/domain/models/Orders';
import FilterParameterOrdersList from '@/domain/models/filter-parameters/FilterParameterOrdersList';
import GroupFilterParametersEnum from '@/domain/enums/GroupFilterParametersEnum';
import AuthenticationModule from '@/stores/modules/AuthenticationModule';
import DataTableHelper from '@/helpers/DataTableHelper';
import DateInputHelper from '@/helpers/DateInputHelper';
import OrderSupport from '@/views/orders/support/OrderSupport';
import FilterParameterHelper from '@/helpers/FilterParameterHelper';
import TableUtils from '@/utils/tableUtils';
import OnRequestTableOptions from '@/types/OnRequestTableOptions';
import VMenuOptions from '@/types/VMenuOptions';
import IVDataTableHeader from '@/types/IVDataTableHeader';
import DataTableFooterOptions from '@/types/DataTableFooterOptions';
import RangeDate from '@/types/RangeDate';
import LooseObjectType from '@/types/LooseObjectType';

@Component({
  components: {
    DynamicColumnMenu,
    ButtonFilterMenuOptions,
  },
})
export default class OrderList extends Vue {
  public search: string = '';
  public consideredColumnToSearch: string = '';

  public loading: Boolean = false;

  public totalItems: number = 0;

  public defaultButtonFilterMenuOption: VMenuOptions | null = null;

  public readonly filterParametersRepository:
    FilterParametersRepository = new FilterParametersRepository();
  public readonly orderRepository: OrderRepository = new OrderRepository();
  public readonly authenticationModule: AuthenticationModule = getModule(AuthenticationModule);
  public readonly orderSupport: OrderSupport = OrderSupport;

  public dataTableOptions: DataOptions = DataTableHelper.getDefaultDataTableOptions();
  public footerOptions: DataTableFooterOptions = DataTableHelper.getDefaultFooterProps();

  public formattedInclusionDate: Partial<RangeDate> = {};
  public headerKeysObject: LooseObjectType<string> = {
    situation: 'data_table_orders_list_show_column_situation',
    number: 'data_table_orders_list_show_column_number',
    companyName: 'data_table_orders_list_show_column_company_name',
    document: 'data_table_orders_list_show_column_document',
    salesChannel: 'data_table_orders_list_show_column_sales_channel',
    inclusionDate: 'data_table_orders_list_show_column_inclusion_date',
  }

  public inclusionDate: Array<string> = []
  public items: Orders[] = [];
  public availableHeaders: IVDataTableHeader[] = [
    { text: 'Situação', value: 'status', show: true },
    { text: 'Número', value: 'number', show: true },
    { text: 'Razão Social', value: 'companyName', show: true },
    { text: 'CNPJ', value: 'document', show: true },
    { text: 'Canal de Vendas', value: 'salesChannel', show: true },
    { text: 'Data de inclusão', value: 'inclusionDate', show: true },
  ];

  public get headers(): IVDataTableHeader[] {
    return this.availableHeaders
      .filter((h) => h.show)
      .concat({
        text: '',
        value: 'actions',
        class: 'action-columns',
        cellClass: 'action-columns',
        sortable: false,
      })
      .concat({
        text: 'column',
        value: 'column',
        class: 'dynamic-columns',
        cellClass: 'dynamic-columns',
        sortable: false,
      });
  }

  public get filtersFromInput(): VMenuOptions[] {
    return this.availableHeaders
      .filter(({ value }) => ['number', 'companyName', 'document'].includes(value))
      .map(({ text, value }) => ({ text, value }));
  }

  @Watch('dataTableOptions')
  onSortDirectionDataTableChange() {
    this.getAllOrders({ resetToFirst: false });
  }

  public async created(): Promise<void> {
    await this.getGroupFilterParameters();
    this.getAllOrders({ resetToFirst: false });
  }

  public async getGroupFilterParameters(): Promise<void> {
    this.loading = true;

    try {
      const filterParameters = await this.filterParametersRepository
        .getFilterByGroup(GroupFilterParametersEnum.ORDERS);
      const formattedFilters = FilterParameterOrdersList.make(filterParameters);

      this.applyFiltersOnActualPage(formattedFilters);
    } catch (error) {
      this.$notification.error('Houve um problema ao requisitar os filtros dessa tela!');
    } finally {
      this.loading = false;
    }
  }

  public applyFiltersOnActualPage(filters: FilterParameterOrdersList): void {
    this.dataTableOptions.sortBy = filters.tableSort;
    this.dataTableOptions.sortDesc = filters.tableDirection;
    this.dataTableOptions.itemsPerPage = filters.rowsPerPage;
    this.dataTableOptions.page = filters.actualPage;

    this.inclusionDate = filters.inclusionDateRange;

    const formattedInclusionDateRange = DateInputHelper
      .formatRangeDate(filters.inclusionDateRange);

    if (formattedInclusionDateRange) {
      this.formattedInclusionDate = formattedInclusionDateRange;
    }

    this.defaultButtonFilterMenuOption = FilterParameterHelper
      .getFormattedColumnObjectOfOptionsButton(this.filtersFromInput, filters.columnToSearch);

    this.availableHeaders = FilterParameterHelper
      .defineColumnsToShowOnSpecificHeader(this.availableHeaders, filters.columnsToShow);
  }

  public async getAllOrders(onRequestTableOptions: OnRequestTableOptions = {}): Promise<void> {
    if (this.loading) {
      return;
    }

    if (onRequestTableOptions.resetToFirst) {
      this.dataTableOptions.page = 1;
    }

    this.loading = true;

    const { sortDesc, sortBy } = this.dataTableOptions;
    const formattedSort = TableUtils.tableOrdenationFormatterToLaravel(sortDesc[0], sortBy[0]);

    try {
      this.filterParametersRepository
        .setFilter(GroupFilterParametersEnum.ORDERS, [
          { key: 'sort_table_orders_list', value: formattedSort },
          { key: 'column_to_search_orders_list', value: this.consideredColumnToSearch },
          { key: 'date_range_orders_list', value: JSON.stringify(this.inclusionDate) },
          { key: 'actual_page_orders_list', value: this.dataTableOptions.page },
          { key: 'rows_per_page_orders_list', value: this.dataTableOptions.itemsPerPage },
        ]);

      const { data, total } = await this.orderRepository.listAll(
        this.authenticationModule.companyIds,
        this.authenticationModule.user.company_group_id,
        {
          search: this.search,
          columnToSearch: this.consideredColumnToSearch,
          initialInclusionDate: this.formattedInclusionDate.initial_date,
          finalInclusionDate: this.formattedInclusionDate.final_date,
          sort: formattedSort,
          actualPage: this.dataTableOptions.page,
          rowsPerPage: this.dataTableOptions.itemsPerPage,
        },
      );

      this.items = data;
      this.totalItems = total;
    } catch (error) {
      this.$notification.error('Houve um problema ao requisitar os pedidos!');
    } finally {
      this.loading = false;
    }
  }

  public handleColumnChange(newColumnPresets: IVDataTableHeader[]): void {
    this.availableHeaders = newColumnPresets;
  }

  public handleClickRow({ innId, customerInnId }: Orders, specificPage: string): void {
    let routeString = `/pedidos/${innId}/${customerInnId}`;

    if (specificPage !== '') {
      routeString += `/${specificPage}`;
    }

    this.$router.push(routeString);
  }

  public handleSearch(search: string): void {
    this.search = search;

    this.getAllOrders({ resetToFirst: false });
  }

  public handleSelectedOptionChange(selectedOption: VMenuOptions | null): void {
    let definedValueToConsider = '';

    if (selectedOption !== null) {
      definedValueToConsider = selectedOption.value;
    }

    this.consideredColumnToSearch = definedValueToConsider;

    if (!this.search) {
      return;
    }

    this.getAllOrders({
      resetToFirst: true,
    });
  }

  public async handleSelectDateRange(): Promise<void> {
    await this.$nextTick();

    const formattedInclusionDate = DateInputHelper.formatRangeDate(this.inclusionDate);

    if (formattedInclusionDate === null) {
      this.$notification.warn('O range de data está inválido!');

      return;
    }

    this.formattedInclusionDate = formattedInclusionDate;

    this.getAllOrders({ resetToFirst: true });
  }
}
